import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-youtube-navbar',
    imports: [],
    templateUrl: './youtube-navbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './youtube-navbar.component.scss'
})
export class YoutubeNavbarComponent {

}
